<div class="discounts-used-container">
  <div class="discounts-used-header">
    <h3 class="discounts-used-title">Discounts Used</h3>
  </div>

  @if (loading) {
    <div class="loading-container">
      <div class="loading-spinner"></div>
      <p>Loading discounts used...</p>
    </div>
  }

  @if (error && !loading) {
    <div class="error-container">
      <div class="error-message">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 9V13M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
            stroke="#DC2626"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <p>{{ error }}</p>
      </div>
      <button type="button" class="retry-btn" (click)="loadDiscountsUsed()">
        <span>Try Again</span>
      </button>
    </div>
  }

  @if (!loading && !error && rows.length === 0) {
    <div class="empty-state-container">
      <div class="empty-state-content">
        <div class="empty-state-illustration">
          <img
            src="assets/images/empty-state-illustration.svg"
            alt="No discounts used illustration"
          />
        </div>
        <div class="empty-state-text">
          <h3 class="empty-state-title">No Discounts Used</h3>
          <p class="empty-state-description">
            This customer has not redeemed any discounts on their orders yet.
          </p>
        </div>
      </div>
    </div>
  }

  @if (!loading && !error && rows.length > 0) {
    <div class="discount-table-wrapper">
      <table class="discount-table" data-testid="discounts-used-table">
        <thead>
          <tr>
            <th>Discount Name</th>
            <th>Discount Type</th>
            <th>Discount Amount</th>
            <th>Order</th>
            <th>Applied Date</th>
          </tr>
        </thead>
        <tbody>
          @for (row of rows; track row.orderUuid) {
            <tr>
              <td>{{ row.discountName }}</td>
              <td>{{ row.discountTypeLabel }}</td>
              <td>{{ row.discountAmountDisplay }}</td>
              <td>
                <button
                  type="button"
                  class="order-link"
                  [attr.aria-label]="'View order ' + row.displayOrderId"
                  (click)="onViewOrder(row)"
                >
                  {{ row.displayOrderId }}
                </button>
              </td>
              <td>
                @if (row.appliedDate) {
                  {{ row.appliedDate | date: 'MMM d y, h:mma' }}
                } @else {
                  -
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</div>
